var exports = {
  "kL": "MatureContentChannelGate.module__container___dDhNWm",
  "Qs": "MatureContentChannelGate.module__content___dDhNWm",
  "DD": "MatureContentChannelGate.module__title___dDhNWm",
  "h_": "MatureContentChannelGate.module__description___dDhNWm",
};

module.exports = exports;
